import { render } from "./Navbar.vue?vue&type=template&id=79b5029c&scoped=true"
const script = {}

import "./Navbar.vue?vue&type=style&index=0&id=79b5029c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-79b5029c"

export default script